import React, { useEffect, useState } from 'react';
import { Image as ImageIcon } from 'lucide-react';

interface ImageZoomProps {
  src: string;
  alt?: string;
  aspectRatio?: string;
  className?: string;
  children?: React.ReactNode;
  onClick?: () => void;
}

const ImageZoom: React.FC<ImageZoomProps> = ({
  src,
  alt = '',
  aspectRatio = '16/9',
  className = '',
  children,
  onClick
}) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [src]);

  return (
    <div
      className={`group/media relative overflow-hidden bg-gray-100 ${onClick ? 'cursor-pointer' : ''} ${className}`}
      style={{ aspectRatio }}
      onClick={onClick}
    >
      {src && !hasError ? (
        <img
          src={src}
          alt={alt}
          className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover/media:scale-105"
          onError={() => setHasError(true)}
        />
      ) : (
        <div className="flex h-full w-full items-center justify-center bg-gray-100 text-gray-300">
          <ImageIcon className="h-8 w-8" />
        </div>
      )}
      {children}
    </div>
  );
};

export default ImageZoom;
